// extracted by mini-css-extract-plugin
export default {"container":"WithdrawCandicacySuccess_container__OCNLP","title":"WithdrawCandicacySuccess_title__SKdwI"};